import packageInfo from '../../../../package.json';

interface AppVersionComponentProps {
    sideMenuView:string
}

const AppVersionComponent = (props: AppVersionComponentProps) => {
    const {sideMenuView} = props;

    return (
        <div className="app-version">
            {
                sideMenuView==="default" ? <>Version {packageInfo.version}</>:
                    <>V &nbsp;{packageInfo.version}</>
            }

        </div>
    );
};

export default AppVersionComponent;